import React, { Fragment } from 'react';
import VgsShowValue from '../VgsInput/VgsShowValue';
import useFieldRevealTracker from '../../hooks/useFieldRevealTracker';

export default function AddressDisplay({
  address,
  onRevealSuccess,
  onRevealFail,
  token,
}: {
  address: Address;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
}): React.JSX.Element {
  const onFieldRevealSuccess = useFieldRevealTracker(onRevealSuccess, [
    'street',
    // 'unit',
    'city',
    'region',
    'postalCode',
  ]);

  const sharedProps = {
    type: 'text' as VgsFieldType,
    onRevealFail,
    token,
  };

  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-1/2 my-2'>
          <VgsShowValue
            value={address.street}
            label='Street'
            onRevealSuccess={onFieldRevealSuccess('street')}
            {...sharedProps}
          />
        </div>

        {/* <div className='md:w-1/2 my-2'>
          <VgsShowValue
            value={address.unit}
            onRevealSuccess={onFieldRevealSuccess('unit')}
            label='Unit'
            {...sharedProps}
          />
        </div> */}
      </div>

      <div className='md:flex mb-5'>
        <div className='md:w-1/3 my-2'>
          <VgsShowValue
            value={address.city}
            label='City'
            onRevealSuccess={onFieldRevealSuccess('city')}
            {...sharedProps}
          />
        </div>
        <div className='md:w-1/3 my-2'>
          <VgsShowValue
            value={address.region}
            onRevealSuccess={onFieldRevealSuccess('region')}
            label='State'
            {...sharedProps}
          />
        </div>
        <div className='md:w-1/3 my-2'>
          <VgsShowValue
            value={address.postalCode}
            onRevealSuccess={onFieldRevealSuccess('postalCode')}
            label='Zip Code'
            {...sharedProps}
          />
        </div>
      </div>
    </Fragment>
  );
}
